import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const trust = [
  { icon: '🔒', text: '100% Free & Secure' },
  { icon: '⚡', text: 'Instant PDF Delivery' },
  { icon: '📊', text: 'Data-Backed Insights' },
];

const LeadForm = () => {
  useEffect(() => {
    const scriptId = 'ghl-form-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://registration.jeruellearning.com/js/form_embed.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="download-form" className="relative py-28 px-4 sm:px-6 lg:px-8 bg-jeruel-dark overflow-hidden">
      {/* Background decoration with photography */}
      <div className="absolute inset-0 pointer-events-none">
        <img 
          src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=80&w=2000" 
          alt="Industrial Technology" 
          className="absolute inset-0 w-full h-full object-cover opacity-10 mix-blend-overlay grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jeruel-dark/50 via-jeruel-dark/80 to-[#111111]" />
        
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-jeruel-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <motion.div 
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-sm font-bold text-white mb-6 backdrop-blur-sm"
          >
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            Available Now For Immediate Download
          </motion.div>
          
          <motion.h2 
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight"
          >
            Where should we send your report?
          </motion.h2>
          
          <motion.p 
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.05 }}
            className="text-xl text-gray-400 font-medium"
          >
            Enter your details below to instantly access the 25-page AI Exposure Analysis for M&R leaders.
          </motion.p>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-2xl shadow-2xl overflow-hidden ring-4 ring-white/10"
          style={{ minHeight: '545px' }}
        >
          <div className="h-2 bg-gradient-to-r from-jeruel-primary via-blue-500 to-teal-400" />
          <div className="p-2 sm:p-4" style={{ minHeight: '545px' }}>
            <iframe
              src="https://registration.jeruellearning.com/widget/form/6iGAzrWYANmWXHKFldeh"
              style={{ width: '100%', border: 'none', borderRadius: '3px', minHeight: '500px', display: 'block' }}
              id="inline-6iGAzrWYANmWXHKFldeh"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="AI exposure analysis for maintenance and reliability"
              data-height="545"
              data-layout-iframe-id="inline-6iGAzrWYANmWXHKFldeh"
              data-form-id="6iGAzrWYANmWXHKFldeh"
              title="AI exposure analysis for maintenance and reliability"
            />
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-8"
        >
          {trust.map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-gray-400 text-sm font-bold">
              <span className="text-xl">{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default LeadForm;